import React from 'react';

function CopilotIcon() {
    return (
        <svg
            viewBox="0 0 24 24"
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M12 4.5V7.5" />
            <path d="M12 16.5V19.5" />
            <path d="M4.5 12H7.5" />
            <path d="M16.5 12H19.5" />
            <path d="M6.8 6.8L8.6 8.6" />
            <path d="M15.4 15.4L17.2 17.2" />
            <path d="M6.8 17.2L8.6 15.4" />
            <path d="M15.4 8.6L17.2 6.8" />
            <circle cx="12" cy="12" r="3.5" />
        </svg>
    )
};

export default CopilotIcon; 